import {
    apiRequest,
    HollydayCreate,
    HollydayCheckdate
} from "../../../../../services/adapters/master/hollydayService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", HollydayCreate, {
            body: query
        }, true)
    }
    fetchCheck = async (query) => {
        return await apiRequest("post", HollydayCheckdate, {
            body: query
        }, true)
    }

}

export default CreateRepository